import store from "../../store";

/**
 * Kill Betby BTRenderer when leaving the sportsbook (Home) page.
 * QA: call kill each time the user leaves or before re-init.
 */
export default (to, from, next) => {
  const state = store.state.slotegator;
  const leavingHome = from && from.name === "Home" && to.name !== "Home";
  const notGoingHome = to.name !== "Home";

  if ((leavingHome || notGoingHome) && state.bt_reader && typeof state.bt_reader.kill === "function") {
    try {
      state.bt_reader.kill();
    } catch (e) {
      console.warn("BTRenderer middleware kill failed", e);
    }
    store.commit("slotegator/SET_BT_READER", null);
  }
  next();
};
